import { base_url } from "../config";
import {
  APPOINTMENTGETOTP,
  APPOINTMENTVERIFYOTP,
  FORGOTPASSWORD,
  LOGIN,
  RESETPASSWORD,
  SIGNIN,
  VERIFYOTP,
  VERIFYPASSWORDOTP,
  VERIFYPHONE,
} from "../endpoint";
import { apiPost } from "../helpers/apiHelpers";
import { apiLoginPost } from "../helpers/apiHelpers";

const login = async (userData) => {
  console.log(userData, "userData from");
  try {
    const response = await apiPost(`${base_url}${SIGNIN}`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};
const forgotPassword = async (data) => {
  try {
    const response = await apiPost(`${base_url}${FORGOTPASSWORD}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const verifyPasswordOtp = async (data) => {
  try {
    const response = await apiPost(`${base_url}${VERIFYPASSWORDOTP}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
const resetPassword = async (data) => {
  try {
    const response = await apiPost(`${base_url}${RESETPASSWORD}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const VerifyOtp = async (userData) => {
  console.log(userData, "userData from");
  try {
    const response = await apiPost(`${base_url}${VERIFYOTP}`, userData);
    return response;
  } catch (error) {
    throw error;
  }
};

const verifyMobile = async (data) => {
  try {
    const response = await apiPost(`${base_url}${VERIFYPHONE}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const AppointmentGetOtp = async (data) => {
  try {
    const response = await apiPost(`${base_url}${APPOINTMENTGETOTP}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const AppointmentVerifyOtp = async (data) => {
  try {
    const response = await apiPost(`${base_url}${APPOINTMENTVERIFYOTP}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

const authService = {
  login,
  forgotPassword,
  verifyPasswordOtp,
  resetPassword,
  VerifyOtp,
  verifyMobile,
  AppointmentVerifyOtp,
  AppointmentGetOtp,
};

export default authService;
